module.exports = {"term_of_service":"Terms of Use","honeowner":"Homeowner"};